import { Outlet } from "react-router";
import { Toaster } from "sonner";
import { Footer } from "../components/Footer";
import NavbarComponent from "../components/Navbar";
import { useAztecWalletInit } from "../hooks/useAztecWallet";

export default function Root() {
  // Initialize Aztec wallet state on app load
  useAztecWalletInit();
  return (
    <div className="h-screen flex flex-col turnstile-bg">
      <NavbarComponent />

      <main className="flex-1">
        <Outlet />
      </main>

      <Footer />

      <Toaster richColors position="top-center" />
    </div>
  );
}
